export default "__VITE_ASSET__iYc6RMf$__"